/**
 * Lab Report Template Service
 * Handles CRUD for lab report extraction templates
 */

import axiosInstance, { apiRequest } from '../axiosInstance';
import { LAB_REPORT_TEMPLATE_ENDPOINTS } from '../endpoints';

const labReportTemplateService = {
  getAll: async () => {
    return apiRequest(() =>
      axiosInstance.get(LAB_REPORT_TEMPLATE_ENDPOINTS.LIST)
    );
  },

  getById: async (id) => {
    return apiRequest(() =>
      axiosInstance.get(LAB_REPORT_TEMPLATE_ENDPOINTS.GET_BY_ID(id))
    );
  },

  create: async (data) => {
    return apiRequest(() =>
      axiosInstance.post(LAB_REPORT_TEMPLATE_ENDPOINTS.CREATE, data)
    );
  },

  update: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.put(LAB_REPORT_TEMPLATE_ENDPOINTS.UPDATE(id), data)
    );
  },

  delete: async (id) => {
    return apiRequest(() =>
      axiosInstance.delete(LAB_REPORT_TEMPLATE_ENDPOINTS.DELETE(id))
    );
  },
};

export default labReportTemplateService;
